import React from 'react';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';

const DialogContainer = styled('div', {
  textAlign: 'center',
});

const StyledFlex = styled(Flex, {
  justifyContent: 'center',
  marginTop: 20,
});

const BoxContainer = styled('div', {
  padding: 20,
});

const StyledBox = styled(Box, {
  position: 'relative',
  padding: '30 !important',
  maxWidth: '55%',
  margin: 'auto',
});

const ContentWrapper = styled('div', {
  padding: '10px 55px',
});

const IconAlert = styled('div', {
  margin: '15px auto',
});

const MiddleText = styled('div', {
  margin: '0px auto',
  textAlign: 'center',
  paddingBottom: '15px',
});

const MarginTop = styled('div', {
  marginTop: 70,
});

export const MaintenanceMessage = () => {
  return (
    <DialogContainer>
      <StyledFlex gutters={[0, 15]} data-testid="ds-error-dialog-area">
        <Flex.Content space-70>
          <MarginTop />
          <BoxContainer>
            <StyledBox data-testid="ds-error-dialog-box" color="$primary2">
              <ContentWrapper>
                <IconAlert>
                  <IconBrand icon="clock" size={48} />
                </IconAlert>
                <h2>We'll be right back!</h2>
                <MiddleText>
                  We sincerely apologize for the inconvenience. Our site is
                  currently undergoing scheduled maintenance and upgrades, but
                  will return shortly. Thank you for your patience.
                </MiddleText>
              </ContentWrapper>
            </StyledBox>
          </BoxContainer>
        </Flex.Content>
      </StyledFlex>
    </DialogContainer>
  );
};
